import { CarouselItem } from '@/components/ui/carousel'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Label } from '@/components/ui/label'
import { useTranslation } from 'react-i18next'
import { useNeedsAnalysis } from '@/contexts/needs-analysis/NeedsAnalysisContext'
import type { TestType } from '@/types/learner-portal'
import { TEST_TYPES } from '@/constants/needsAnalysis'

export default function TestTypeScreen() {
  const { t } = useTranslation()
  const { goal_specification, setTestType } = useNeedsAnalysis()
  return (
    <CarouselItem className='px-2 sm:px-8'>
      <div className='space-y-2 py-2 sm:space-y-6 sm:py-6'>
        <div className='space-y-1 sm:space-y-2'>
          <h3 id='test-type-heading' className='text-base font-medium text-gray-900 sm:text-xl'>
            {t('needsAnalysis.testType.title')}
          </h3>
        </div>

        <RadioGroup
          aria-labelledby='test-type-heading'
          value={goal_specification || undefined}
          onValueChange={(val) => setTestType(val as TestType)}
          className='space-y-2 sm:space-y-3'
        >
          {TEST_TYPES.map((testType) => (
            <Label
              key={testType}
              htmlFor={`test-${testType}`}
              className='flex cursor-pointer items-center space-x-2 rounded-lg border border-gray-200 p-2 transition-colors hover:bg-gray-50 sm:space-x-3 sm:p-4'
            >
              <RadioGroupItem value={testType} id={`test-${testType}`} />
              <span className='flex-1 text-sm font-medium sm:text-base'>
                {t(`needsAnalysis.testType.tests.${testType}`)}
              </span>
            </Label>
          ))}
        </RadioGroup>
      </div>
    </CarouselItem>
  )
}
